import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { useTheme, buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import useMobileLayout from 'Hooks/useMobileLayout';
import fr from 'facet-rest';
import {
  MobileThreadQuickActions,
} from 'Views/Page/Content/Templates/MessagesPage/components/MessagesPageContent/components/ThreadQuickActions/MobileThreadQuickActions';
import {
  DesktopThreadQuickActions,
} from 'Views/Page/Content/Templates/MessagesPage/components/MessagesPageContent/components/ThreadQuickActions/DesktopThreadQuickActions';

const useStyles = buildUseStyles('ThreadQuickActions', () => ({
  root: {
    display: 'flex',
    alignItems: 'center',
  },
}));

const ThreadQuickActions = forwardRef(({
  className,
  threadResource,
  size,
  color,
  style, // MUI requires style to be passed into use with transition components (ex. Fade)
  enableMemberNavigationLinks,
  memberThreadParticipant,
}, ref) => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const isMobile = useMobileLayout();

  const ThreadQuickActionComponent = isMobile ? MobileThreadQuickActions : DesktopThreadQuickActions;

  return (
    <Box
      className={classNames(classes.root, className)}
      style={style}
      ref={ref}
    >
      <ThreadQuickActionComponent
        threadResource={threadResource}
        color={color}
        size={size}
        enableMemberNavigationLinks={enableMemberNavigationLinks}
        memberThreadParticipant={memberThreadParticipant}
      />
    </Box>
  );
});

ThreadQuickActions.defaultProps = {
  className: '',
  size: 'default',
  style: {},
  color: 'actionActive',
  enableMemberNavigationLinks: false,
  memberThreadParticipant: undefined,
};

ThreadQuickActions.propTypes = {
  className: PropTypes.string,
  threadResource: PropTypes.instanceOf(fr.Resource).isRequired,
  memberThreadParticipant: PropTypes.instanceOf(fr.Resource),
  size: PropTypes.string,
  style: PropTypes.object,
  color: PropTypes.string,
  enableMemberNavigationLinks: PropTypes.bool,
};

export { ThreadQuickActions };
